import { createStyles, getStylesRef } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	itemWrapper: {
		[`&:hover .${getStylesRef('buttonWrapper')}`]: {
			display: 'block',
		},
	},
	entityLink: {
		padding: theme.spacing.xs,
		borderRadius: theme.radius.sm,
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		cursor: 'pointer',
	},
	iconWrapper: {
		paddingTop: theme.other.space[1],
	},
	label: {
		overflowWrap: 'anywhere',
	},
	buttonWrapper: {
		ref: getStylesRef('buttonWrapper'),
		display: 'none',
	},
}));
